export default __webpack_public_path__ + "static/media/20201102_175836.3fd01ddc.jpg";